import { render, staticRenderFns } from "./CategoryFormFields.vue?vue&type=template&id=34600d92"
import script from "./CategoryFormFields.vue?vue&type=script&lang=ts"
export * from "./CategoryFormFields.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports